import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styled from 'styled-components';
import { H3 } from './../../components/typography/Headings';

const Wrapper = styled.div`
  height: 295px;
  border-radius: 3px;
  transition: box-shadow 300ms ease;
  position: relative;
  overflow: hidden;

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 20px 0 #c7c7c7;
  }
`;

const Title = styled(H3)`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  min-height: 30%;
  color: #fff;
  padding: 20px 10px;
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(2, 2, 2, 1) 99%,
    #000000 100%
  );
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
`;

const CollectionCard = props => {
  return (
    <Link
      href={`/${props.locale}/playlists/collections/${props.slug}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Wrapper>
        <Image
          src={props.thumbnailUrl}
          alt=""
          layout="fill"
          objectFit="cover"
        />
        <Title bold>{props.name}</Title>
      </Wrapper>
    </Link>
  );
};

export default CollectionCard;
